export const poi: {
    id: string;
    label: string;
}[] = [
    {
        id: '925',
        label: 'Chaîne des Puys'
    },
    {
        id: '927',
        label: 'Cirque de Gavarnie'
    },
    {
        id: '933',
        label: "Lac d'Aiguebelette"
    },
    {
        id: '952',
        label: 'Parc Naturel Régional de Chartreuse'
    },
    {
        id: '935',
        label: 'Lac de Gérardmer'
    },
    {
        id: '955',
        label: 'Parc Naturel Régional du Queyras'
    },
    {
        id: '944',
        label: 'Massif des Aravis'
    },
    {
        id: '945',
        label: 'Massif du Beaufortain'
    },
    {
        id: '930',
        label: 'Col du Galibier'
    },
    {
        id: '958',
        label: "Vallée de l'Ubaye"
    },
    {
        id: '942',
        label: 'Lac du Bourget'
    },
    {
        id: '943',
        label: 'Lac Léman'
    },
    {
        id: '957',
        label: 'Plateau des Glières'
    },
    {
        id: '946',
        label: 'Massif du Dévoluy'
    },
    {
        id: '940',
        label: 'Lac des Hermines'
    },
    {
        id: '939',
        label: 'Lac de Vouglans'
    },
    {
        id: '932',
        label: 'Col du Tourmalet'
    },
    {
        id: '948',
        label: 'Parc National de la Vanoise'
    },
    {
        id: '947',
        label: 'Mont Blanc'
    },
    {
        id: '953',
        label: "Parc Naturel régional des Volcans d'Auvergne"
    },
    {
        id: '934',
        label: "Lac d'Annecy"
    },
    {
        id: '937',
        label: 'Lac de Monteynard'
    },
    {
        id: '938',
        label: 'Lac de Serre-Ponçon'
    },
    {
        id: '956',
        label: 'Parc Naturel Régional du Vercors'
    },
    {
        id: '954',
        label: 'Parc Naturel Régional du massif des Bauges'
    },
    {
        id: '950',
        label: 'Parc National des Pyrénées'
    },
    {
        id: '951',
        label: 'Parc National du Mercantour'
    },
    {
        id: '949',
        label: 'Parc National des Ecrins'
    },
    {
        id: '929',
        label: 'Cirque du Fer à Cheval'
    },
    {
        id: '931',
        label: 'Col du Lautaret'
    },
    {
        id: '936',
        label: 'Lac de Matemale'
    },
    {
        id: '941',
        label: 'Lac des Rousses'
    },
    {
        id: '959',
        label: "Ballon d'Alsace"
    }
]